import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CpfCnpjPipeModule } from '@toro/common/shared/pipes';
import { BankInfoBoxComponent } from './bank-info-box.component';

@NgModule({
    imports: [
        CommonModule,
        CpfCnpjPipeModule,
    ],
    declarations: [
        BankInfoBoxComponent,
    ],
    exports: [
        BankInfoBoxComponent
    ]
})
export class BankInfoBoxModule {}
